import { render, staticRenderFns } from "./VorgeschlageneDiagnoseComponent.vue?vue&type=template&id=2f9f6d68&scoped=true"
import script from "./VorgeschlageneDiagnoseComponent.vue?vue&type=script&lang=js"
export * from "./VorgeschlageneDiagnoseComponent.vue?vue&type=script&lang=js"
import style0 from "./VorgeschlageneDiagnoseComponent.vue?vue&type=style&index=0&id=2f9f6d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9f6d68",
  null
  
)

export default component.exports